// Classes.
import {Article} from './article';


export class SearchResults {


  public totalResults: number;
  public page: number;
  public resultsPerPage: number;
  public rawItems: any[];
  public items: any[];

  public constructor(rawSearchResults: any) {
    this.totalResults = rawSearchResults.pageInfo.totalResults;
    this.page = rawSearchResults.pageInfo.page;
    this.resultsPerPage = rawSearchResults.pageInfo.resultsPerPage;
    this.items = rawSearchResults.items;
  };
}
